/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Skill_LevelInputs */

const en_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Level`)
};

const es_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de habilidad`)
};

const fr_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau de compétence`)
};

const de_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwierigkeitsgrad`)
};

const ja_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象スキルレベル`)
};

const zh_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技能水平要求`)
};

const ar_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستوى المهارة`)
};

const id_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat Keahlian`)
};

const it_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello di Difficoltà`)
};

const ru_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уровень подготовки`)
};

const pt_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível de Habilidade`)
};

const ko_field_skill_level = /** @type {(inputs: Field_Skill_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`권장 스킬 레벨`)
};

/**
* | output |
* | --- |
* | "Skill Level" |
*
* @param {Field_Skill_LevelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_skill_level = /** @type {((inputs?: Field_Skill_LevelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Skill_LevelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_skill_level(inputs)
	if (locale === "es") return es_field_skill_level(inputs)
	if (locale === "fr") return fr_field_skill_level(inputs)
	if (locale === "de") return de_field_skill_level(inputs)
	if (locale === "ja") return ja_field_skill_level(inputs)
	if (locale === "zh") return zh_field_skill_level(inputs)
	if (locale === "ar") return ar_field_skill_level(inputs)
	if (locale === "id") return id_field_skill_level(inputs)
	if (locale === "it") return it_field_skill_level(inputs)
	if (locale === "ru") return ru_field_skill_level(inputs)
	if (locale === "pt") return pt_field_skill_level(inputs)
	return ko_field_skill_level(inputs)
});